import { FC, PropsWithChildren, createContext, useContext } from 'react';

const CoreContext = createContext<any>(null);

const CoreProvider: FC<PropsWithChildren> = ({ children }) => {
  const realtimeDbPath: [string] = ['core'];

  return (
    <CoreContext.Provider
      value={{
        realtimeDbPath: [realtimeDbPath.join('/')],
      }}
    >
      {children}
    </CoreContext.Provider>
  );
};

interface CoreContextProps {
  realtimeDbPath: [string];
}

const useCoreContext = (): CoreContextProps => useContext(CoreContext);

export { CoreProvider, useCoreContext };
